import { z } from "zod";
/**
 * A buyer's book design (owner decision 2026-10-09): one of five original layout templates, its
 * options, and the design kit version that styles it. A book without a design keeps the classic
 * layout, so every book made before templates compiles and renders exactly as it did.
 *
 * Kept in its own module so the publication plan and the template catalog can both depend on it.
 */
export const bedtimeLayoutTemplateIdSchema = z.enum([
    "STORYBOOK_MIX",
    "LITTLE_MOMENTS",
    "WIDE_SKIES",
    "PICTURE_AND_PAGE",
    "BOLD_MOMENTS",
]);
/**
 * Where story text tends to sit. Real books vary text position spread by spread (the corpus places
 * 44% of story blocks at the top, 30% at the bottom and 26% in the middle, in six or more distinct
 * zones per book), so each emphasis is a designed, varied sequence rather than one fixed band.
 */
export const bedtimeTemplateTextEmphasisSchema = z.enum([
    "BALANCED",
    "MOSTLY_TOP",
    "MOSTLY_BOTTOM",
]);
export const bedtimeTemplatePaperSchema = z.enum(["WARM_CREAM", "WHITE"]);
export const bedtimeLayoutTemplateOptionsSchema = z
    .object({
    textEmphasis: bedtimeTemplateTextEmphasisSchema,
    paper: bedtimeTemplatePaperSchema,
})
    .strict();
const semverSchema = z.string().regex(/^\d+\.\d+\.\d+$/u);
export const bedtimeBookDesignV1Schema = z
    .object({
    contract: z.literal("BEDTIME_BOOK_DESIGN_V1"),
    templateId: bedtimeLayoutTemplateIdSchema,
    templateVersion: semverSchema,
    options: bedtimeLayoutTemplateOptionsSchema,
    designKitVersion: semverSchema,
})
    .strict();
/** The stored choice for one book: the design, plus who chose it and when. */
export const bedtimeBookDesignRecordV1Schema = z
    .object({
    contract: z.literal("BEDTIME_BOOK_DESIGN_RECORD_V1"),
    bookId: z.string().trim().min(1).max(240),
    revision: z.number().int().positive(),
    design: bedtimeBookDesignV1Schema,
    chosenAt: z.string().datetime({ offset: true }),
    chosenByActorId: z.string().trim().min(1).max(240),
})
    .strict();
/** A buyer's request to choose or change the design; the server fills in the versions. */
export const bedtimeBookDesignCommandV1Schema = z
    .object({
    templateId: bedtimeLayoutTemplateIdSchema,
    options: bedtimeLayoutTemplateOptionsSchema,
    /** The revision the buyer saw (0 when the book has no design yet). */
    expectedRevision: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=bedtime-book-design.js.map